module.exports = __webpack_public_path__ + "fonts/CalibreRegular.c5b01b24.woff";